import { useEffect } from 'react'

import {
  CameraSelection,
  MicSelection,
  useMeetingManager,
} from 'amazon-chime-sdk-component-library-react'
import { AudioInputDevice, VideoInputDevice } from 'amazon-chime-sdk-js'
import { Modal } from 'antd'

function saveVideoInput(device?: VideoInputDevice) {
  if (device) {
    localStorage.setItem('videoInput', device.toString())
  }
}

function saveAudioInput(device?: AudioInputDevice) {
  if (device) {
    localStorage.setItem('audioInput', device.toString())
  }
}

export function DeviceSettingModal({
  open,
  onClose = undefined,
}: {
  open: boolean
  onClose?: () => void | undefined
}) {
  const meetingManager = useMeetingManager()

  useEffect(() => {
    if (!open) {
      return
    }

    // Subscribe to device changes while the modal is open,
    // and save the selected devices to localStorage.
    //
    // subscribeToSelectedVideoInputDevice / subscribeToSelectedAudioInputDevice
    // immediately call the provided callback with the current (default) device,
    // even if the user hasn't manually changed anything.
    // Then, whenever the user changes the device via the MicSelection or
    // CameraSelection components, the callback is triggered again.
    // This ensures that both the initial default device and any updates
    // are saved to localStorage while the modal is open.
    meetingManager.subscribeToSelectedVideoInputDevice(saveVideoInput)
    meetingManager.subscribeToSelectedAudioInputDevice(saveAudioInput)

    return () => {
      meetingManager.unsubscribeFromSelectedVideoInputDevice(saveVideoInput)
      meetingManager.unsubscribeFromSelectedAudioInputDevice(saveAudioInput)
    }
  }, [open, meetingManager])

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered>
      <MicSelection />
      <CameraSelection />
    </Modal>
  )
}
